module.exports = __webpack_public_path__ + "img/cloud-download.661a2a98.svg";